module.exports = __webpack_public_path__ + "img/map.be14abce.jpg";